import React from "react";
import Menu from "../components/Dashboard/Menu";
import Container from "../components/Dashboard/Container";

const Dashboard = () => {
  return (
    <div>
      <Menu />
      <Container />
    </div>
  );
};

export default Dashboard;